<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ded">
<p class="ded"><a class="page" id="pv"></a><i>This book is dedicated to the memory of my father, who so often showed me the way; and to Tayhas, who brings the light.</i></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-krause-0005.vue?56939a25